(() => {
  'use strict';

  const VERSION = '1.0.0';
  const mobileQuery = window.matchMedia('(max-width: 768px)');
  const isHome = () => document.body?.classList.contains('template-index');

  const pauseVideo = (video, unload = false) => {
    try { video.pause(); } catch (_) {}
    video.autoplay = false;
    video.removeAttribute('autoplay');

    if (!unload) return;
    video.querySelectorAll('source').forEach((source) => {
      if (source.hasAttribute('src')) {
        source.dataset.moztechMobileSrc = source.getAttribute('src');
        source.removeAttribute('src');
      }
      source.removeAttribute('data-src');
    });
    video.removeAttribute('src');
    try { video.load(); } catch (_) {}
  };

  const setStaticStory = (scope = document) => {
    scope.querySelectorAll?.('[data-moztech-illuminated-story]').forEach((root) => {
      root._moztechIlluminatedJourney?.destroy?.();
      root.classList.add('is-mobile-lite');
      root.classList.remove('is-motion-active');
      root.dataset.storyState = 'mobile-static';
      root.style.setProperty('--story-progress', '1');
      root.querySelectorAll('[data-story-item], [data-story-intro]').forEach((item) => {
        item.style.removeProperty('left');
        item.style.removeProperty('top');
        item.style.removeProperty('opacity');
        item.style.removeProperty('filter');
        item.style.removeProperty('transform');
        item.style.removeProperty('--story-reveal-right');
      });
    });
  };

  const setStaticHero = (scope = document) => {
    scope.querySelectorAll?.('[data-moztech-hero]').forEach((root) => {
      root._moztechBurnReveal?.destroy?.();
      root._moztechHeroExperience?.destroy?.();
      root.classList.add('is-mobile-lite', 'is-media-ready', 'is-burn-complete');
      root.classList.remove('is-burn-active', 'is-burn-reversing');
      root.dataset.burnState = 'mobile-static';
      root.dataset.mediaState = 'poster-only';
      root.style.setProperty('--moz-burn-content-opacity', '1');
      root.style.setProperty('--moz-burn-content-y', '0px');
      root.style.setProperty('--moz-burn-dock-opacity', '1');
      root.style.setProperty('--moz-burn-dock-y', '0px');
      root.style.setProperty('--moz-burn-media-opacity', '1');
      root.querySelectorAll('video').forEach((video) => pauseVideo(video, true));
    });
  };

  let belowFoldObserver;
  const manageBelowFoldVideo = () => {
    belowFoldObserver?.disconnect();
    if (!('IntersectionObserver' in window)) return;

    belowFoldObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!entry.isIntersecting) {
          pauseVideo(video);
          return;
        }
        if (video.dataset.moztechMobileAutoplay === 'true') {
          video.play().catch(() => {});
        }
      });
    }, { rootMargin: '30% 0px', threshold: 0.01 });

    document.querySelectorAll('#MainContent video').forEach((video) => {
      if (video.closest('[data-moztech-hero]')) return;
      video.dataset.moztechMobileAutoplay = String(video.autoplay || video.hasAttribute('autoplay'));
      belowFoldObserver.observe(video);
    });
  };

  const apply = (scope = document) => {
    if (!mobileQuery.matches || !isHome()) return;
    document.documentElement.classList.add('moztech-mobile-home-lite');
    setStaticStory(scope);
    setStaticHero(scope);
    manageBelowFoldVideo();
  };

  const boot = () => {
    if (!mobileQuery.matches || !isHome()) return;
    apply(document);
    requestAnimationFrame(() => apply(document));
    window.setTimeout(() => apply(document), 800);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => apply(event.target));
  mobileQuery.addEventListener?.('change', () => {
    if (mobileQuery.matches) boot();
    else window.location.reload();
  });

  window.MoztechMobileHomePerformance = { version: VERSION, apply };
})();
